import React from 'react';

import { CoreIcon } from '@aspid/ui';
import { Button } from '@mui/material';


import type { BaseButtonProperties } from './BaseButton.types';

export const BaseButton: React.FC<BaseButtonProperties> = ({
  dataTest = 'base_button',
  size = 'large',
  icon,
  disabled,
  children,
  color,
  onClick,
  type,
  sx,
  variant = 'outlined',
  form,
  startIcon,
  id,
}) => {
  return (
    <Button
      id={id}
      data-testid={dataTest}
      size={size}
      color={color}
      type={type}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      sx={sx}
      form={form}
      startIcon={startIcon}
    >
      {icon && (
        <CoreIcon dataTest={`${dataTest}_icon`} icon={icon} sx={{ mr: 1 }} />
      )}
      {children}
    </Button>
  );
};
